import { dependabilityV2Colors } from '@/styles/colors';

const TIER_COLORS: Record<string, string> = {
  monitored: dependabilityV2Colors.depTierMonitored,
  standard: dependabilityV2Colors.depTierStandard,
  gold: dependabilityV2Colors.depTierGold,
  platinum: dependabilityV2Colors.depTierPlatinum,
};

// The score ring (digits + arc) uses its own per-tier accent, distinct from
// the pill palette: red / blue / green / slate as the score climbs. Hexes read
// off the score text layers in the GravyWork-2.0-Baseline frames.
const SCORE_COLORS: Record<string, string> = {
  monitored: dependabilityV2Colors.depTierMonitored,
  standard: dependabilityV2Colors.depScoreStandard,
  gold: dependabilityV2Colors.depPositive,
  platinum: dependabilityV2Colors.depScorePlatinum,
};

// Ring-arc gradients per tier (the arc is a gradient, distinct from the flat
// digit color). Gold was verified from the rendered Figma export; the other
// three pairs were provided by design (2026-07-15). Ends reuse existing
// palette entries; unknown tiers fall back to a flat scoreColor arc.
const RING_GRADIENTS: Record<string, [string, string]> = {
  monitored: [
    dependabilityV2Colors.depRingMonitoredStart,
    dependabilityV2Colors.depTierMonitored,
  ],
  standard: [
    dependabilityV2Colors.depRingStandardStart,
    dependabilityV2Colors.depScoreStandard,
  ],
  gold: [
    dependabilityV2Colors.depRingGoldStart,
    dependabilityV2Colors.depRingGoldEnd,
  ],
  platinum: [
    dependabilityV2Colors.depRingPlatinumStart,
    dependabilityV2Colors.depTierPlatinum,
  ],
};

const FALLBACK = '#6C757D';

export const tierColor = (tier: string | null | undefined): string =>
  (tier && TIER_COLORS[tier]) || FALLBACK;

export const scoreColor = (tier: string | null | undefined): string =>
  (tier && SCORE_COLORS[tier]) || dependabilityV2Colors.depInk;

export const ringGradient = (
  tier: string | null | undefined,
): [string, string] | null => (tier && RING_GRADIENTS[tier]) || null;

export const categoryColor = (
  category: 'positive' | 'negative' | 'neutral',
): string => {
  if (category === 'positive') return dependabilityV2Colors.depPositive;
  if (category === 'negative') return dependabilityV2Colors.depTierMonitored;
  return FALLBACK;
};

// Activity-feed accent bars use a third palette: green / amber / red for
// positive / neutral / negative entries ("Late checked in" arrives as a
// neutral checkin_recorded event, which is exactly the design's amber case).
export const feedAccentColor = (
  category: 'positive' | 'negative' | 'neutral',
): string => {
  if (category === 'positive') return dependabilityV2Colors.depFeedPositive;
  if (category === 'negative') return dependabilityV2Colors.depTierMonitored;
  return dependabilityV2Colors.depFeedNeutral;
};
